import { render } from "./Claim.vue?vue&type=template&id=c64b6f3e&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"

import "./Claim.vue?vue&type=style&index=0&id=c64b6f3e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64b6f3e"]])

export default __exports__